// @flow
import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  title: string,
  isActive: boolean,
  onClick: () => void,
  imageSrc: string,
};

export const IconFilterItem = (props: Props) => {
  const { isActive, onClick, title, imageSrc } = props;
  const className = classNames(
    title === 'Completed'
      ? 'icon-filter-item green'
      : title === 'Ongoing'
      ? 'icon-filter-item coral'
      : title === 'Upcoming'
      ? 'icon-filter-item grey'
      : 'icon-filter-item',
    {
      active: isActive,
    }
  );

  return (
    <div className={className} onClick={onClick}>
      <img src={imageSrc} alt={'icon'} />
      {title}
    </div>
  );
};
